import * as constAction from 'root/actionConstants';
import { env_production } from 'core/constants';

export const getRoles = () => ({
  type: constAction.USER_GET_ROLES,
  epic: {
    url: 'usuarios/getRoles',
    method: 'GET',
  },
});

export const getUserData = () => ({
  type: constAction.USER_GET_DATA,
  epic: {
    url: 'usuarios/getMyData',
    method: 'GET',
    toCore: true,
  },
});

export const setState = values => ({
  type: constAction.USER_SET_STATE,
  payload: values,
});

export const setRolesState = response => ({
  type: constAction.USER_ROLES_SET_STATE,
  payload: {
    roles: response,
  },
});

export const redirect = () => ({
  type: constAction.USER_REDIRECT,
});

export const verifyEmail = codigo => ({
  type: constAction.USER_VERIFYEMAIL,
  payload: { codigo },
  epic: {
    url: 'usuarios/confirmar',
    method: 'POST',
  },
});

export const login = (email, password) => ({
  type: constAction.USER_LOGIN,
  payload: {
    email,
    password,
  },
  epic: {
    url: 'usuarios/login',
    method: 'POST',
  },
});

export const loginStorage = user => ({
  type: constAction.USER_SET_STORAGE,
  payload: user,
});

export const checkLogin = () => ({
  type: constAction.USER_CHECK_LOGIN,
});

export const logout = () =>
  env_production && {
    type: constAction.USER_LOGOUT,
  };

export const register = data => ({
  type: constAction.USER_REGISTER,
  payload: data,
  epic: {
    url: 'usuarios',
    method: 'POST',
  },
});

export const recuperarContrasena = (email, codigo, password) => ({
  type: constAction.USER_RECUPERAR_CONTRASENA,
  payload: email ? { email } : { codigo, password },
  epic: {
    url: email ? 'usuarios/askReset' : 'usuarios/resetPassword',
    method: 'POST',
  },
});

export const contrasenaCambiada = () => ({
  type: constAction.USER_CONTRASENA_CAMBIADA,
});



// WEBPACK FOOTER //
// src/modules/user/action.js